import React, { useState, useEffect } from "react";
import "antd/dist/antd.min.css";

import { Breadcrumb, Layout, Menu, Typography } from "antd";
import { Space, Table, Tag, Button } from "antd";
import { Link, Route, Routes } from "react-router-dom";
import PageWrapper from "../helpers/PageWrapper";
import TokenService from "../../services/token.service";
import authAxios from "../../services/api";

// window.location.reload();

const HomePage = () => {
  const [teachers, setTeacher] = useState([]);
  const [teacherId, setTeacherId] = useState();
  useEffect(() => {
    authAxios.get(`http://85.159.27.198:8080/abitur/api/auth/get_by_userid/${TokenService.getLocalUserId()}`, {
      headers: {
        'Authorization': 'Bearer ' + TokenService.getLocalAccessToken()
      }
    }).then((response) => {
      authAxios.get(`http://85.159.27.198:8080/abitur/api/v1/teacher/${response.data.id}`, {
        headers: {
          'Authorization': 'Bearer ' + TokenService.getLocalAccessToken()
        }
      }).then((response) => {
        setTeacher(response.data)
        console.log(response.data)
      });
    });
  }, [])
  const name = teachers.name
  const surname = teachers.surname
  const patronymic = teachers.patronymic


   

 
    
      return (
        <PageWrapper>
            
       <Typography.Title level={1}>Добро пожаловать, {surname}  {name} {patronymic}</Typography.Title>
        

             
              </PageWrapper>

        

      )
  
}

export default HomePage